import script from "./Page4.vue?vue&type=script&setup=true&lang=js"
export * from "./Page4.vue?vue&type=script&setup=true&lang=js"

import "./Page4.vue?vue&type=style&index=0&id=58d3fbc2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d3fbc2"]])

export default __exports__